<template>
    <div>
        <div class="kit__utils__heading">
            <h5><span class="mr-3">{{this.$route.meta.title}}</span></h5>
        </div>
        <div class="card">
            <div class="card-header card-header-flex">
                <search v-bind="sentDataSearch"></search>
            </div>
        </div>
        <div class="card">
        <sumtransection></sumtransection>
        </div>
        <div class="card">
            <div class="card-body">
                <h5>เอเจนท์</h5>
                <hr>
                <tableAgentSBO></tableAgentSBO>
            </div>
        </div>
        <!-- <div>
          <div class="card-body">
            <tableProvider></tableProvider>
          </div>
        </div> -->
         <!-- <div class="card">
            <div class="card-body">
                <h5>ฝากเงิน</h5> -->
                <provider></provider>
            <!-- </div>
        </div> -->
      <!--   <div class="card">
            <div class="card-body">
                <h5>ถอนเงิน</h5>
                <tableWithdraw></tableWithdraw>
            </div>
        </div> -->
    </div>
  </template>

<script>
// import apiClient from '@/services/api'
import tableAgentSBO from './tableAgentSBO'
import provider from './provider'
// import tableProvider from './tableProvider'
// import tableWithdraw from './tableWithdraw'
import sumtransection from './sumTransection'
import search from '@/components/system/table/search/sbo/transection.vue'
export default {
  components: {
    sumtransection,
    tableAgentSBO,
    provider,
    // tableProvider,
    // tableDeposit,
    // tableWithdraw,
    search,
  },
  data() {
    return {
      pageType: 'transectionSBO',
    }
  },
  computed: {
    sentDataSearch: function() {
      return {
        pageType: this.pageType,
      }
    },
  },
  methods: {

  },
}
</script>

  <style>

  </style>
